module.exports = __webpack_public_path__ + "static/img/store_logo.1bf49bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/store_logo.png
// module id = Shap
// module chunks = 1